import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography } from '@mui/material';

const InfoRow = ({ title, data, clickable, onClick, children, titleSx, editing, ...rest }) => (
    <Box display="flex" alignItems="flex-start" {...rest}>
        <Typography
            sx={theme => ({
                fontWeight: 600,
                flex: '0 1 50%',
                paddingRight: 1,
                ...(typeof titleSx === 'function' ? titleSx(theme) : titleSx),
            })}
        >
            {title}
            {'\xa0'}:
        </Typography>
        <Box flex="1 1">
            {children && (data === '-' || editing) ? (
                children
            ) : (
                <Typography
                    color={clickable ? 'primary' : null}
                    sx={
                        clickable
                            ? {
                                  '&:hover': {
                                      textDecoration: 'underline',
                                      cursor: 'pointer',
                                  },
                              }
                            : undefined
                    }
                    component="span"
                    onClick={clickable ? onClick : null}
                >
                    {data}
                </Typography>
            )}
        </Box>
    </Box>
);

InfoRow.propTypes = {
    editing: PropTypes.bool,
    title: PropTypes.string,
    data: PropTypes.any,
    children: PropTypes.node,
    clickable: PropTypes.bool,
    onClick: PropTypes.func,
    titleSx: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
};

export default InfoRow;
